import React from "react";
import { useTranslation } from "react-i18next";
import { ComingSoonScreen } from "./ComingSoonScreen";

/** Megaphone icon for the Kampagnen placeholder. */
const MegaphoneIcon: React.FC = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 11v2a1 1 0 0 0 1 1h2l4 4V6L6 10H4a1 1 0 0 0-1 1Z" />
    <path d="M10 6l8-3v18l-8-3M18 9a3 3 0 0 1 0 6" />
  </svg>
);

/** Campaigns placeholder (FE-7): title + centered coming-soon card. German UI copy. */
export const CampaignsScreen: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ComingSoonScreen
      title={t("placeholders.kampagnen.title")}
      subtitle={t("placeholders.kampagnen.subtitle")}
      icon={<MegaphoneIcon />}
      cardTitle={t("placeholders.kampagnen.cardTitle")}
      cardBody={t("placeholders.kampagnen.cardBody")}
    />
  );
};
